export default __webpack_public_path__ + "static/media/warmup cues-01 1.104d7d2a.svg";